module.exports = __webpack_public_path__ + "static/img/aiTeacherAvatar.802a64b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pblCourse/aiTeacherAvatar.png
// module id = nq6M
// module chunks = 4